/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />

import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import $ from 'jquery';
var Config: any = require('../../Config.json');
var self;
var Config: any = require('../../Config.json');

export interface StatusFilter {
    statusData: any[]
    AllReefer_Count: number
    Running_Count: number
    Stopped_Count: number
    MissedRunning_Count: number
    MissedStopped_Count: number
    AllMicroAlaram_Count: number
    MASevere_Count: number
    MAMinor_Count: number
    AllCargoCare_Count: number
    CCSevere_Count: number
    CCMinor_Count: number
    CCInformational_Count: number
    reeferStatusFilters: ReeferStatusFilters
}
interface ReeferStatusFilters {
    AllReefer: boolean,
    Running: boolean,
    Stopped: boolean,
    MissedRunning: boolean,
    MissedStopped: boolean,
    AllMicroAlaram: boolean,
    MASevere: boolean,
    MAMinor: boolean,
    AllCargoCare: boolean,
    CCSevere: boolean,
    CCMinor: boolean,
    CCInformational: boolean
}
const emptySearchFilters = {
    AllReefer: false, Running: false, Stopped: false, MissedRunning: false, MissedStopped: false, AllMicroAlaram: false, MASevere: false, MAMinor: false, AllCargoCare: false, CCSevere: false, CCMinor: false, CCInformational: false
};
var isPanelLoaded;
export class ReeferToggleButtonsFilter extends React.Component<any, StatusFilter> {
    constructor(props: any) {
        super(props);
        this.state = {
            statusData: [],
            AllReefer_Count: 0,
            Running_Count: 0,
            Stopped_Count: 0,
            MissedRunning_Count: 0,
            MissedStopped_Count: 0,
            AllMicroAlaram_Count: 0,
            MASevere_Count: 0,
            MAMinor_Count: 0,
            AllCargoCare_Count: 0,
            CCSevere_Count: 0,
            CCMinor_Count: 0,
            CCInformational_Count: 0,
            reeferStatusFilters: emptySearchFilters
        }

        self = this;
        isPanelLoaded = false;
    }

    componentWillReceiveProps(nextprops: any) {
        if (nextprops.gridData != undefined && nextprops.gridData != null && isPanelLoaded == true) {
            this.setStatusFilters(nextprops);
        }
        if (!isPanelLoaded) {
            isPanelLoaded = true;
        }
    }

    setStatusFilters(nextprops: any) {
        self.setState({
            isPanelLoaded: true,
            statusData: nextprops.gridData,
            AllReefer_Count: nextprops.gridData.length,
            Running_Count: nextprops.gridData.filter(x => x.RunState == "I").length,
            MissedRunning_Count: nextprops.gridData.filter(x => x.RunState == "S").length,
            Stopped_Count: nextprops.gridData.filter(x => x.RunState == "X").length,
            MissedStopped_Count: nextprops.gridData.filter(x => x.RunState == "O").length,
            AllMicroAlaram_Count: nextprops.gridData.filter(x => x.MicroAlarms != null && x.MicroAlarms != "" && (x.MASeverityLevel == 1 || x.MASeverityLevel == 2)).length,
            MASevere_Count: nextprops.gridData.filter(x => x.MicroAlarms != null && x.MicroAlarms != "" && x.MASeverityLevel != null && x.MASeverityLevel == 1).length,
            MAMinor_Count: nextprops.gridData.filter(x => x.MicroAlarms != null && x.MicroAlarms != "" && x.MASeverityLevel != null && x.MASeverityLevel == 2).length,
            AllCargoCare_Count: nextprops.gridData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && x.CCSeverityLevel != "").length,
            CCSevere_Count: nextprops.gridData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && (x.CCSeverityLevel != "" && x.CCSeverityLevel == 1)).length,
            CCMinor_Count: nextprops.gridData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && (x.CCSeverityLevel != "" && x.CCSeverityLevel == 2)).length,
            CCInformational_Count: nextprops.gridData.filter(x => x.CCAlarms != null && x.CCAlarms != "" && (x.CCSeverityLevel != "" && x.CCSeverityLevel == 3)).length
        });
    }

    //ApplyStatusFilter(param: string) {
    //    self.props.filterReeferStatusGrid(param);
    //}
    ApplyStatusFilter(param: string, event: React.FormEvent<HTMLInputElement>) {
        var searchFilter = this.state.reeferStatusFilters;
        var isChecked: boolean = event.currentTarget.checked;
        switch (param) {
            case "AllReefer":
                searchFilter.AllReefer = isChecked;
                break;
            case "Running":
                searchFilter.Running = isChecked;
                break
            case "MissedRunning":
                searchFilter.MissedRunning = isChecked;
                break;
            case "Stopped":
                searchFilter.Stopped = isChecked;
                break;
            case "MissedStopped":
                searchFilter.MissedStopped = isChecked;
                break;
            case "AllMicroAlaram":
                searchFilter.AllMicroAlaram = isChecked;
                break;
            case "MASevere":
                searchFilter.MASevere = isChecked;
                break;
            case "MAMinor":
                searchFilter.MAMinor = isChecked;
                break;
            case "AllCargoCare":
                searchFilter.AllCargoCare = isChecked;
                break;
            case "CCSevere":
                searchFilter.CCSevere = isChecked;
                break;
            case "CCMinor":
                searchFilter.CCMinor = isChecked;
                break;
            case "CCInformational":
                searchFilter.CCInformational = isChecked;
                break;
        }

        this.setState({
            reeferStatusFilters: searchFilter
        });

        self.props.filterReeferStatusGrid(searchFilter);
    }

    static ClearToggleFilters() {
        if (self != undefined) {
            var searchFilter = self.state.reeferStatusFilters;
            searchFilter.AllReefer = false;
            searchFilter.Running = false;
            searchFilter.MissedRunning = false;
            searchFilter.Stopped = false;
            searchFilter.MissedStopped = false;
            searchFilter.AllMicroAlaram = false;
            searchFilter.MASevere = false;
            searchFilter.MAMinor = false;
            searchFilter.AllCargoCare = false;
            searchFilter.CCSevere = false;
            searchFilter.CCMinor = false;
            searchFilter.CCInformational = false;
            self.setState({
                reeferStatusFilters: searchFilter
            });
        }
    }

    ClearReeferStatusFilters() {
        var searchFilter = self.state.reeferStatusFilters;
        searchFilter.AllReefer = false;
        searchFilter.Running = false;
        searchFilter.MissedRunning = false;
        searchFilter.Stopped = false;
        searchFilter.MissedStopped = false;
        searchFilter.AllMicroAlaram = false;
        searchFilter.MASevere = false;
        searchFilter.MAMinor = false;
        searchFilter.AllCargoCare = false;
        searchFilter.CCSevere = false;
        searchFilter.CCMinor = false;
        searchFilter.CCInformational = false;
        self.setState({
            reeferStatusFilters: searchFilter
        });

        self.props.filterReeferStatusGrid(searchFilter);
    }

    public render() {

        return <div>
            <form>
               
                    <div className="btn-group btn-group-sm btn-group-dsd" role="group">
                        <button type="button" className="btn btn-outline-secondary" onClick={self.ClearReeferStatusFilters.bind(this)}>
                            <span className="fa-solid fa-trash-can me-1 fa-sm"></span>
                            Clear filters
                        </button>

                        <button type="button" className="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                            <span className="fa-solid fa-filter me-1 fa-sm"></span>
                            Apply filters
                            <span className="caret"></span>
                        </button>
                        <div className='dropdown-menu dropdown-menu-end'>
                            <div className='d-flex gap-2 px-2'>

                                <ul className='list-group'>
                                    <li className="list-group-item d-flex align-items-center fw-medium">Grid Filters</li>
                                    <li className="list-group-item d-flex align-items-center">  <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.AllReefer} onChange={this.ApplyStatusFilter.bind(this, 'AllReefer')} /> <span className='form-check-label me-3'> Total Reefers </span> <span className="badge rounded-pill green ms-auto"> {this.state.AllReefer_Count} </span>  </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.Running} onChange={this.ApplyStatusFilter.bind(this, 'Running')} /> <span className='form-check-label me-3'> Running and Operational </span>  <span className="badge rounded-pill green ms-auto green">  {this.state.Running_Count}  </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.MissedRunning} onChange={this.ApplyStatusFilter.bind(this, 'MissedRunning')} /> <span className='form-check-label me-3'> On Standby </span> <span className="badge rounded-pill green ms-auto greybg"> {this.state.MissedRunning_Count}  </span> </li>
                                    <li className="list-group-item d-flex align-items-center"><input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.Stopped} onChange={this.ApplyStatusFilter.bind(this, 'Stopped')} /> <span className='form-check-label me-3'> Shut Down or Faulty </span> <span className="badge rounded-pill green ms-auto orange"> {this.state.Stopped_Count}  </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.MissedStopped} onChange={this.ApplyStatusFilter.bind(this, 'MissedStopped')} /> <span className='form-check-label me-3'> Offline or Powered Down </span> <span className="badge rounded-pill green ms-auto light-grey" >  {this.state.MissedStopped_Count}  </span> </li>
                                </ul>

                                <ul className='list-group'>
                                    <li className="list-group-item d-flex align-items-center fw-medium"> Micro Alarms</li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.AllMicroAlaram} onChange={this.ApplyStatusFilter.bind(this, 'AllMicroAlaram')} /> <span className='form-check-label me-3'> Total Reefers </span> <span className="badge rounded-pill green ms-auto"> {this.state.AllMicroAlaram_Count} </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.MASevere} onChange={this.ApplyStatusFilter.bind(this, 'MASevere')} /> <span className='form-check-label me-3'> Severe </span> <span className="badge rounded-pill green ms-auto severe"> {this.state.MASevere_Count} </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.MAMinor} onChange={this.ApplyStatusFilter.bind(this, 'MAMinor')} /> <span className='form-check-label me-3'> Minor </span>  <span className="badge rounded-pill green ms-auto minor"> {this.state.MAMinor_Count} </span> </li>
                                </ul>

                                <ul className='list-group'>
                                    <li className="list-group-item d-flex align-items-center fw-medium"> CargoCare Alarms </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.AllCargoCare} onChange={this.ApplyStatusFilter.bind(this, 'AllCargoCare')} /> <span className='form-check-label me-3'> Total Reefers </span>  <span className="badge rounded-pill green ms-auto"> {this.state.AllCargoCare_Count} </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.CCSevere} onChange={this.ApplyStatusFilter.bind(this, 'CCSevere')} /> <span className='form-check-label me-3'> Severe </span>  <span className="badge rounded-pill green ms-auto severe"> {this.state.CCSevere_Count} </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.CCMinor} onChange={this.ApplyStatusFilter.bind(this, 'CCMinor')} /> <span className='form-check-label me-3'> Minor </span>  <span className="badge rounded-pill green ms-auto minor"> {this.state.CCMinor_Count} </span> </li>
                                    <li className="list-group-item d-flex align-items-center"> <input className="form-check-input me-2" type="checkbox" checked={this.state.reeferStatusFilters.CCInformational} onChange={this.ApplyStatusFilter.bind(this, 'CCInformational')} /> <span className='form-check-label me-3'>  Informational </span> <span className="badge rounded-pill green ms-auto informational"> {this.state.CCInformational_Count} </span> </li>
                                </ul>

                            </div>
                        </div>
                    </div>
              
            </form>
        </div>;
    }
}

